var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowLeftEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8903_307933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9325L10 5.06752C10 4.6436 9.50557 4.41202 9.17991 4.68341L4.46093 8.61589C4.22106 8.81579 4.22105 9.18421 4.46093 9.38411L9.17991 13.3166C9.50557 13.588 10 13.3564 10 12.9325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.9325L16 5.06752C16 4.6436 15.5056 4.41202 15.1799 4.68341L10.4609 8.61589C10.2211 8.81579 10.2211 9.18421 10.4609 9.38411L15.1799 13.3166C15.5056 13.588 16 13.3564 16 12.9325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 1,
    height: 10,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8903_307933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeftEnd);
export default __webpack_public_path__ + "static/media/ic-arrow-left-end.b6a10f395b507ce700b06b3815d7918b.svg";
export { ForwardRef as ReactComponent };